import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {OutlinedInput} from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'
import SearchBar from 'components/Forms/SearchBar'
import useCustomerRegistration from 'features/invoice/useInvoiceList'
import {useLocation} from 'react-router-dom'
import {getQueryFromUrl} from 'helpers/commonHelper'

interface Status {
  name: string
  oid: string
}

interface Region {
  name: string
  value: string
}

export default function InstitutionSearch() {
  const classes = useToolbarStyles()
  const location = useLocation()
  const outlinedInputClasses = useOutlinedInputStyles()
  const {query, onSearch, setConfirmed} = useCustomerRegistration()

  const {t} = useTranslation()

  const allStatus: Status[] = [
    {
      name: t('IAllInvoice'),
      oid: '1',
    },
    {
      name: t('IComplete'),
      oid: '2',
    },
    {
      name: t('IWriting'),
      oid: '3',
    },
  ]
  const allRegion: Region[] = [
    {name: t('ITargetNation'), value: ''},
    {name: t('IDomestic'), value: 'Domestic'},
    {name: t('IOverseas'), value: 'Overseas'},
  ]

  const [searchKeyword, setSearchKeyword] = useState('')
  const [searchConditionStatus, setConditionStatus] = useState<any>()
  const [searchConditionRegion, setConditionRegion] = useState('')
  const handleValue = (value: any) => {
    setSearchKeyword(value)
  }

  const getSearch = () => {
    return {
      ...query,
      orgName: searchKeyword,
      region: searchConditionRegion,
    }
  }

  const handleChangeStatus = (value: string) => {
    setConditionStatus(value)
    switch (value) {
      case '2':
        setConfirmed(true)
        break
      case '3':
        setConfirmed(false)
        break
      default:
        setConfirmed(null)
        break
    }
  }

  const handleChangeTerm = (value: string) => {
    setConditionRegion(value)
  }

  const handleSearch = () => {
    const newSearch = getSearch()
    onSearch(newSearch)
  }

  /** Set default value for search condition if it is stored in url */
  useEffect(() => {
    const searchParams = getQueryFromUrl(location.search)
    if (searchParams?.region) setConditionRegion(searchParams.region || '')
    if (searchParams.isConfirmed) {
      setConfirmed(searchParams.isConfirmed)
      switch (searchParams.isConfirmed) {
        case true:
          setConditionStatus('2')
          break
        case false:
          setConditionStatus('3')
          break
        default:
          setConditionStatus('1')
          break
      }
    }
  }, [])

  return (
    <div style={{display: 'flex', gap: 17, justifyContent: 'space-between'}}>
      <FormControl variant='outlined'>
        <div
          style={{display: 'flex', gap: 17, justifyContent: 'space-between'}}
        >
          <Select
            value={searchConditionStatus || allStatus[0]?.oid}
            displayEmpty
            className={classes.searchSelectInvoice}
            onChange={(event) => {
              handleChangeStatus(event.target.value as string)
            }}
            input={<OutlinedInput classes={outlinedInputClasses} />}
          >
            {allStatus?.map((item) => (
              <MenuItem value={item.oid} key={item.oid}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </FormControl>
      <FormControl variant='outlined'>
        <div
          style={{display: 'flex', gap: 17, justifyContent: 'space-between'}}
        >
          <Select
            value={searchConditionRegion || allRegion[0]?.value}
            displayEmpty
            className={classes.searchSelectInvoice}
            onChange={(event) => {
              handleChangeTerm(event.target.value as string)
            }}
            input={<OutlinedInput classes={outlinedInputClasses} />}
          >
            {allRegion?.map((item) => (
              <MenuItem value={item.value} key={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </FormControl>
      <FormControl variant='outlined'>
        <div
          style={{display: 'flex', gap: 17, justifyContent: 'space-between'}}
        >
          <SearchBar
            onChangeValue={handleValue}
            onSearchEvent={handleSearch}
            disabledValue={false}
          />
        </div>
      </FormControl>
    </div>
  )
}
